import * as React from 'react';
import { ProgressBar, Tooltip } from '@fluentui/react-components';
import { Warning20Regular } from '@fluentui/react-icons';
import { COLORS, COVERAGE_CELL_STYLES, COVERAGE_TOOLTIP } from '../policies/constants';

type Props = {
  countLabel: string; // e.g. "8/12"
  percent: number; // 0..100
  warnCount?: number; // partially deployed count
  warnNoun?: 'SIT' | 'label' | 'policy'; // for tooltip text
  barMaxWidth?: number; // default 140
  ariaLabel?: string; // Accessibility label for the progress bar
};

export default function CoverageCell({
  countLabel,
  percent,
  warnCount = 0,
  warnNoun = 'label',
  barMaxWidth = 140,
  ariaLabel,
}: Props) {
  const hasWarn = warnCount > 0;

  // Generate a descriptive aria-label if not provided
  const progressAriaLabel =
    ariaLabel || `${warnNoun} coverage: ${countLabel} (${Math.round(percent)}% complete)`;

  return (
    <div style={COVERAGE_CELL_STYLES.container}>
      <span style={COVERAGE_CELL_STYLES.countLabel}>{countLabel}</span>
      <div style={COVERAGE_CELL_STYLES.barWrapper(barMaxWidth)}>
        <ProgressBar
          value={percent / 100}
          thickness="medium"
          style={COVERAGE_CELL_STYLES.progressBar}
          aria-label={progressAriaLabel}
        />
      </div>
      {hasWarn && (
        <Tooltip
          content={
            <div>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>{COVERAGE_TOOLTIP.title}</div>
              <div>
                {COVERAGE_TOOLTIP.description(warnCount, warnNoun)}
              </div>
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                {COVERAGE_TOOLTIP.hint}
              </div>
            </div>
          }
          relationship="label"
        >
          <Warning20Regular
            style={{ color: COLORS.warning, cursor: 'help' }}
            aria-label={`${warnCount} tenant(s) partially deployed`}
          />
        </Tooltip>
      )}
    </div>
  );
}
